module.exports = __webpack_public_path__ + "img/img1.be5ae13e.png";